import React from 'react'
import styled from '@emotion/styled'
import { useHostContextFeature } from '@mobi/account/Hooks'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { colors, font, radius, spacing } from '@mobi/component-library/Foundations'
import { FeatureFlags } from '@mobi/settings/featureFlags'

const FastWithdrawalMarketing = () => {
  const fastWithdrawalMarketingBanner = useHostContextFeature(
    FeatureFlags.FAST_WITHDRAW_MARKETING_BANNER.key
  )

  if (!fastWithdrawalMarketingBanner) return null

  return (
    <FastWithdrawalMarketingCard>
      <FastWithdrawalMarketingHeader>
        <Icon name='DuocolorZapFast' size='3.4rem' color={colors.bondi[400]} />
      </FastWithdrawalMarketingHeader>

      <FastWithdrawalTitle>Fast withdrawals are now available!</FastWithdrawalTitle>
      <FastWithdrawalText>
        Complete a PayID deposit successfully, and you can withdraw to the same bank account in just
        seconds.
      </FastWithdrawalText>
    </FastWithdrawalMarketingCard>
  )
}

const FastWithdrawalMarketingCard = styled.section({
  backgroundColor: colors.white,
  border: `0.1rem solid ${colors.neutral[200]}`,
  borderRadius: radius.lgx2,
  marginTop: spacing.md,
  padding: spacing.md,
})

const FastWithdrawalMarketingHeader = styled.div({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: spacing.sm,
})

const FastWithdrawalTitle = styled.h3({
  textTransform: 'none',
  backgroundColor: colors.white,
  color: colors.black,
  fontWeight: font.weight.semibold,
  margin: 0,
  padding: 0,
  ...font.size.xl,
})

const FastWithdrawalText = styled.div({
  color: colors.neutral[900],
  fontWeight: font.weight.regular,
  margin: `${spacing.smx2} 0 0`,
  ...font.size.md,
})

export default FastWithdrawalMarketing
